export enum ERole {
  DEVELOPER = 'developer',
  ADMIN = 'admin',
  USER = 'user',
}
